<template>
  <div class="run-state today-alarm">
    <nk-box-title :icon-class="'iconfont icon-yunhangzhuangtai1'" :title="'运行状态'">
      <!-- <div slot="title" class="logo"> -->
      <div slot="title" >
          <!-- 插槽的内容 -->
      </div>
      <div class="content dn-content-bg" >
        <div class="param-item">
          <label class="title">更新时间:<span class="time">{{nowTime}}</span></label>
        </div>
        <div class="main-centent ">
          <div class="main-top" style="position: relative;">
                <i class="el-icon-arrow-left arrowLeft"  @click="move(false)"></i>
                <i class="el-icon-arrow-right arrowRight"  @click="move(true)"></i>
                <div class="aq " v-for="(item,index) in originalData" :key="index">
                    <div class="ico-img">
                        <p class="ico-box"><i :class="item.icon" ></i></p>
                        <p class="ico-zt zt">{{item.displayName}}</p>
                    </div>
                    <p class="main-value dn-content-bg" :class="{'spanColor':item.name!='--' }">{{item.value}}<span class="small">{{item.unit}}</span></p>
                </div>
            </div>
          <div class="main-bottom">
            <div class="aq" v-for="(item,index) in urlData" :key="index"  >
                <div class="ico-img xqh" @click="jamp(item.url)" >
                    <p class="ico-box"><i :class="item.iconFont" ></i></p>
                </div>
                <p class="main-value dn-content-bg zt qh" >{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </nk-box-title>
  </div>
</template>
<script>
import NkBoxTitle from "@/components/common/NkBoxTitle.vue";
import dateTool from '@/utils/dateTool' 
export default {
  components: { NkBoxTitle },
  data() {
    return {
        nowTime:"",
        time:60,
        interTime:null,
        originalData:[],
        topPower:[
            {
                icon:'iconfont icon-yougonggongshuai',
                name:'total_ACTIVE_POWER',
                value:'',
                displayName:'有功功率',
                unit:''
            },
            {
                icon:'iconfont icon-wugonggongshuai',
                name:'total_REACTIVE_POWER',
                value:'',
                displayName:'无功功率',
                unit:''
            },
            {
                icon:'iconfont icon-zongdianliang',
                name:'total_energe',
                value:'',
                displayName:'总电量',
                unit:''
            },
            {
                icon:'iconfont icon-zongfeiyong',
                name:'total_charge',
                value:'',
                displayName:'总电费',
                unit:''
            },
        ],
        urlData:[
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-peidiantu',
                name:'配电图'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-fadianji',
                name:'发电机'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-bianyaqi',
                name:'变压器'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-tongxun',
                name:'通讯'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-peidiantu',
                name:'发电机'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-kongtiaoxitong',
                name:'空调系统'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-geishuixitong',
                name:'给水系统'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-donglixitong',
                name:'动力系统'
            },
            {
                url:"/power/ProfileInformation",
                iconFont:'iconfont icon-ranqixitong',
                name:'燃气系统'
            }
        ]
};
  },
  created() {
      let time=new Date()
      this.nowTime=dateTool.format(time,'yyyy-MM-dd hh:mm:ss')
      this.getData()
  },
  mounted() {
      let vm=this
  },
  methods: {
        getData(){
            let vm = this
            let topPower=JSON.parse(JSON.stringify(vm.topPower))
            topPower.pop()
            Promise.all(topPower.map(k => api.measuring.getLatestMeasuringValue(this.control.measureId || '10498721634770944', k.pointCode, 0))).then(res => {
                if(res.every(k => k.success)){
                    vm.loading=false
                
                    let unit=['kw','kVar','kW•h','元']
                    topPower.forEach((item, i)=>{
                        item.value = res[i].data.value
                        item.unit = unit[i]
                    })
                    vm.originalData=[]
                    for(let i=0;i<topPower.length;i++){
                        vm.originalData.push(topPower[i])
                    }              
                    this.loading = false;
                    if(vm.interTime){
                        clearTimeout(vm.interTime);
                    }
                    if((vm.control.time) > 0){
                        vm.interTime = setTimeout(() => {
                            vm.getData()
                        }, (vm.control.time) * 1000);
                    }
                }else{
                    if(vm.interTime){
                        clearTimeout(vm.interTime);
                    }
                    if(vm.time > 0){
                        vm.interTime = setTimeout(() => {
                            vm.getData()
                        }, vm.time * 1000);
                    }
                }
            }).catch(error=>{
                vm.$messge.error(error.msg)
            })
        },
        //页面跳转
        jamp(path){
            this.$router.push({ path: path });
        },
        //向左
        move(type){
            let vm=this
            let originalData = JSON.parse(JSON.stringify(vm.originalData))  //3
            let topPower = JSON.parse(JSON.stringify(vm.topPower))  //4
            if(type){//右
                originalData.pop();//尾部删一个
                let firstIndexInoriginal = topPower.findIndex(obj => obj.name === originalData[0].name); //头部加一个
                firstIndexInoriginal <= 0 ? firstIndexInoriginal = topPower.length : "";
                originalData.unshift(topPower[firstIndexInoriginal - 1]);
            }else{
                originalData.shift();//头部删一个
                let lastIndexInoriginal = topPower.findIndex(obj => obj.name === originalData[originalData.length - 1].name); //尾部加一个
                lastIndexInoriginal >= topPower.length - 1 ? lastIndexInoriginal = -1 : "";
                originalData.push(topPower[lastIndexInoriginal + 1]);
            }
            vm.originalData=JSON.parse(JSON.stringify(originalData))
        }
  },
};
</script>
<style lang="scss" scoped>
.spanColor{
    color: rgba(242, 178, 54);
}
.run-state {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  .logo {
    line-height: 25px;
    display: flex;
    flex-flow: row;
    color: rgba(30, 30, 30);
    margin-left: 5px;
    .logoImg {
      margin-right: 5px;
    }
  }
  .content {
    display: flex;
    flex: 1;
    flex-flow: column;
    min-width: 450px;
    padding: 0 8px;
    box-sizing: border-box;
    color: #181818;
    .param-item {
      line-height: 50px;
      text-align: left;
      .title {
        font-size: 14px;
        color: #666;
      }
      .time{
            margin-left: 10px;
            color: rgba(119, 194, 240);
      }
    }
    .main-centent{
        display: flex;
        flex: 1;
        flex-flow: column;
        .main-top{
            display: flex;
            flex: 1; 
            flex-flow: row;
            .aq{
                display: flex;
                flex: 1;
                flex-flow: column;
                margin: 0 5px;
                .ico-img{
                    display: flex;
                    flex: 2;
                    justify-content: center;
                    align-items: center;
                    flex-flow: column;
                    .ico-box{
                        margin: 0;
                        margin-bottom:4px;
                        width: 58px;
                        height: 58px;
                        // background: rgba(237, 241, 242);
                        // border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 37px;
                            color: rgba(59, 173, 238)
                        }}
                    .ico-zt{
                        margin: 0;
                        font-size:12px
                    }
                }
                .main-value{
                    margin: 0;
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    align-items: flex-end;
                    font-size: 34px;
                    // color: rgba(242, 178, 54);
                    .small{
                        font-size: 16px;
                        padding-bottom: 5px;
                        box-sizing: border-box;
                    }
                }
            }
        }  
        .main-bottom{
            display: flex;
            flex: 1; 
            flex-flow: row;
            padding: 10px 0;
            .aq{
                display: flex;
                flex: 1;
                flex-flow: column;
                // background: rgba(247, 249, 248);
                margin: 0 2px;
                .ico-img{
                    display: flex;
                    flex: 2;
                    justify-content: center;
                    align-items: center;
                    flex-flow: column;
                    cursor: pointer;
                    .ico-box{
                        margin: 0;
                        margin-bottom:4px;
                        // background: rgba(237, 241, 242);
                        // border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 35px;
                            color: rgba(59, 173, 238)
                        }}
                    .ico-zt{
                        margin: 0;
                        font-size:12px
                    }
                }
                .main-value{
                    margin: 0;
                    display: flex;
                    flex: 1;
                    justify-content: center;
                    // background: rgba(232, 237, 240);
                    align-items: center;
                    font-size: 12px;
                    border-radius: 3px;
                }
            }
        }  
    }
  }
}
.arrowLeft{
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: .3s;
    position: absolute;
    top: 50%;
    z-index: 10;
    transform: translateY(-50%);
    text-align: center;
    font-size: 25px;
    left: 16px;
    color:rgba(1, 151, 238)
  }
  .arrowRight{
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: absolute;
    top: 50%;
    z-index: 10;
    transform: translateY(-50%);
    text-align: center;
    font-size: 25px;
    right: 16px;
    color:rgba(1, 151, 238)
  }
</style>
